var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["edit-text.j2"] = require( "edit-text.j2" );
dependencies["quickshop-text.j2"] = require( "quickshop-text.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-product-tile-quickshop.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/core-product-tile-quickshop.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("quickshopUrl")) {
var t_4 = t_1.quickshopUrl;
} else {
cb(new Error("cannot import 'quickshopUrl'")); return;
}
context.setVariable("quickshopUrl", t_4);
output += "\n\n<a href=\"";
output += runtime.suppressValue((lineno = 2, colno = 22, runtime.callWrap(t_4, "quickshopUrl", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product")),"productSlug"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product")),"queryParams")])), env.opts.autoescape);
output += "\"\n   class=\"c-product-tile-controls__quickshop-link js-product-tile-control-quickshop\"\n   ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"cartItemId")) {
output += " data-cart-item-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"cartItemId"), env.opts.autoescape);
output += "\" ";
;
}
output += "\n   data-qa-quickshop-button\n   ";
if(runtime.contextOrFrameLookup(context, frame, "analyticsQuickShop")) {
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "analyticsQuickShop"), env.opts.autoescape);
output += " ";
;
}
output += "\n>\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isOwner") == runtime.contextOrFrameLookup(context, frame, "True")) {
output += "\n        ";
env.getTemplate("edit-text.j2", false, "core/templates/core-product-tile-quickshop.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n    ";
})});
}
else {
output += "\n        ";
env.getTemplate("quickshop-text.j2", false, "core/templates/core-product-tile-quickshop.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n    ";
})});
}
output += "\n</a>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-product-tile-quickshop.j2"] , dependencies)